import { Checkbox } from '@mui/material';
import { DataCellProps } from '../types';

export const TeamsV2CheckboxCell = ({ team, _customRowProps }: DataCellProps) => {
  const { selectedIds, onToggleRow } = _customRowProps;
  const checked = selectedIds.has(team.id);
  return (
    <Checkbox
      checked={checked}
      onClick={(e) => {
        e.stopPropagation();
        onToggleRow(team.id);
      }}
    />
  );
};

export default TeamsV2CheckboxCell;
